var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-table"},_vm._l((_vm.tableData),function(row,index){return _c('checkbox-grid',{key:index,attrs:{"formData":row['odds'],"colCount":row['colCount']},on:{"update:selected-data":function($event){return _vm.handleSelectedData(index, $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }